import styled, { createGlobalStyle } from 'styled-components'

/**
 * Global styles for the Onfido SDK container.
 *
 * Note: Typed as `any` to work around a TypeScript compatibility issue with styled-components.
 * The error "cannot be used as a JSX component" occurs due to version mismatches between
 * styled-components, React, and TypeScript where the return type of createGlobalStyle
 * is not recognized as a valid JSX element type.
 *
 * This is a known issue and the `any` type is a safe workaround since createGlobalStyle
 * components are designed to be used as JSX elements.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const GlobalEntrustStyles: any = createGlobalStyle`
  #onfido-sdk {
    margin: 0 auto;
    max-height: 100%;
    min-height: auto !important;
  }
  
  @media only screen and (min-width: 768px) {
    #onfido-sdk {
      max-height: 800px;
    }
  }
`

export const EntrustMount = styled.div`
  display: flex;
  height: 100%;
  position: relative;
  width: 100%;
  align-items: center;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  height: 100%;
  margin: 0;
`

export const List = styled.ul`
  display: flex;
  margin: 0 auto;
  padding: 12px;
  flex-shrink: 0;
  list-style-type: none;
`

export const Item = styled.li`
  margin: 0;
  padding: 0 16px 0 0;
  list-style-type: none;
`

export const Link = styled.a`
  color: rgb(54, 64, 245);
  display: block;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  margin: 0;
  text-decoration: underline;
`
